import type DeviceStatusModel from 'garaje/models/device-status';

/**
 * Device-type classification shared by every surface that lists iPads
 * (DeviceModel, the per-location iPads page, the Global Overview iPads page).
 * Keep the rules here — duplicating the prefixes at call sites is how the
 * per-location and Global Overview pages ended up disagreeing (SQ-7730).
 */

// x86_ covers Intel-based iOS simulators; arm64 covers Apple Silicon simulators.
export function isSimulatorDeviceType(deviceType: string | null | undefined): boolean {
  if (!deviceType) return false;
  return deviceType.startsWith('x86_') || deviceType.startsWith('arm64');
}

export function isIpadDeviceType(deviceType: string | null | undefined): boolean {
  if (!deviceType) return false;
  return deviceType.startsWith('iPad') || isSimulatorDeviceType(deviceType);
}

/**
 * Whether a devices-service status should appear in an iPads list. Grounded in
 * telemetry (not the store's device record) on purpose: an abandoned enrollment
 * with empty telemetry can wear envoy-web attributes acquired through a printers
 * `include=devices` sideload — the telemetry push has nothing to overwrite them
 * with — and a record-based check would list that ghost as a plausible iPad.
 */
export function isListableIpadStatus(status: DeviceStatusModel, { showSimulators = false } = {}): boolean {
  const deviceType = status.deviceType;
  if (!isIpadDeviceType(deviceType)) return false;
  return showSimulators || !isSimulatorDeviceType(deviceType);
}
